import styled from "styled-components/macro";
import { Container as BSContainer } from "reactstrap";

const Container = styled(BSContainer)`
  max-width: 850px;
`;

export default Container;
